/*
 * @Author: zys22 226208335@qq.com
 * @Date: 2025-10-10 09:59:43
 * @LastEditors: zys22 226208335@qq.com
 * @LastEditTime: 2026-10-12 15:08:03
 * @FilePath: /frasergen-weixin-web/src/App.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import {Route, Routes } from 'react-router-dom'

import { HashRouter, history } from './utils/history'

import './App.css';
import Login from '@/pages/Login/login'
import Layout from '@/pages/Layout/layout'
import ContractProgress from '@/pages/ContractProgress/contract_progress'
import ContractManagement from '@/pages/ContractManagement/contract_management'
import InvoiceManagement from '@/pages/InvoiceManagement/invoice_management'
import PaymentCollection from '@/pages/PaymentCollection/payment_collection'
import PaymentTransfer from '@/pages/PaymentTransfer/payment_transfer'

import { AuthRoute } from '@/components/AuthRoute'


function App() {
  return (
    <HashRouter history={history}>
      {/* <HistoryRouter history={history}> */}
        <div className="App">
          <Routes>
            <Route path='/' element={
              <AuthRoute>
                <Layout />
              </AuthRoute>
            } >
              <Route path='/contract_progress' element={<ContractProgress />} />
              <Route path='/contract_management' element={<ContractManagement />} />
              <Route path='/invoice_management' element={<InvoiceManagement />} />
              <Route path='/payment_transfer' element={<PaymentTransfer />} />
              <Route path='/payment_collection' element={<PaymentCollection />} />
              
            </Route>
            <Route path='/login' element={<Login /> }/>
             
          </Routes>
        </div>
      {/* </HistoryRouter> */}
    </HashRouter>
    
    
  );
}

export default App;
